import {
  APICurrentUserConfidentialFieldPermissions,
  ArdoqId,
} from '@ardoq/api-types';
import { confidentialFieldPermissionsOperations } from '@ardoq/access-control';

export const affectedWorkspacesByConfidentialFieldPermissionChange = (
  previous: APICurrentUserConfidentialFieldPermissions,
  current: APICurrentUserConfidentialFieldPermissions,
  fieldsToWorkspaces: Record<string, Set<ArdoqId>>
): ArdoqId[] => {
  if (previous.userCanSeeAllFields !== current.userCanSeeAllFields) {
    const allWorkspaces = new Set<ArdoqId>();
    for (const workspaceSet of Object.values(fieldsToWorkspaces)) {
      for (const workspaceId of workspaceSet) {
        allWorkspaces.add(workspaceId);
      }
    }
    return [...allWorkspaces];
  }

  if (current.userCanSeeAllFields) {
    return [];
  }

  const affectedWorkspaces = new Set<ArdoqId>();
  const allConfidentialFields = new Set([
    ...previous.allConfidentialFieldNames,
    ...current.allConfidentialFieldNames,
  ]);

  for (const fieldName of allConfidentialFields) {
    const workspacesUsingField = fieldsToWorkspaces[fieldName];
    if (!workspacesUsingField) continue;

    for (const workspaceId of workspacesUsingField) {
      const prevCanSee =
        confidentialFieldPermissionsOperations.canSeeConfidentialFieldByName(
          previous,
          fieldName,
          workspaceId
        );
      const currCanSee =
        confidentialFieldPermissionsOperations.canSeeConfidentialFieldByName(
          current,
          fieldName,
          workspaceId
        );

      if (prevCanSee !== currCanSee) {
        affectedWorkspaces.add(workspaceId);
      }
    }
  }

  return [...affectedWorkspaces];
};
